import type { PlaylistDesign__PlaylistItem as PlaylistItem } from '../index.generated';

export const EMPTY_ITEMS: readonly PlaylistItem[] = [];
